import store from '../redux/store/index';

export function menuEntry(code) {
    let allMenuEntry = store.getState().user?.menuEntries
    return allMenuEntry?.find(e => e.code === code) ? true : false;
}